import {SubService, SubServiceInitState} from '@/store/subservice/subservice.types';
import {SubServiceAction} from '@/store/subservice/subservice.actions';
import {SubServiceMutations} from '@/store/subservice/subservice.mutations';

const namespaced = true;

export const subServiceInitState: SubServiceInitState = {
  subService: [{}] as SubService[]
};

export const subServiceState = {
  namespaced,
  state: subServiceInitState,
  actions: SubServiceAction,
  mutations: SubServiceMutations,
  // getters
};
